<script>export let text = undefined;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
</script>

<div
  style={stringifyStyles({
    outline: "none",
  })}
  class="builder-text"
>
  {@html text?.toString() || ""}
</div>